(function ($) {
  DJ.addBehavior('contentTabs', '.content-tabs', {
    attach: function () {
      const contentTabs = this;
      const navigationBtn = contentTabs.querySelectorAll('.content-tabs__button');
      const navigationBtnActiveClass = 'content-tabs__button--active';
      const tabBody = contentTabs.querySelector('.content-tabs__body');
      const tabContent = tabBody.querySelectorAll('.content-tabs__tab');
      const tabContentHiddenClass = 'content-tabs__tab--hidden';
      const locationHash = window.location.hash;
      const currentButton = $(`a[href="${locationHash}"]`);

      /**
       * Refresh js elements inside tab to show them correctly (form elements, sliders etc.).
       */
      const refreshElements = () => {
        const mimSchoolSlider = document.querySelector('.mim-school-about__slider');
        const genericBlockWithScroll = $('.generic-block--scrollable .generic-block__body');

        jcf.refreshAll();

        if (genericBlockWithScroll) {
          jcf.destroy(genericBlockWithScroll);
          jcf.replace(genericBlockWithScroll, 'Scrollable');
        }

        if (mimSchoolSlider && mimSchoolSlider.getAttribute('data-slider-init')) {
          $(mimSchoolSlider).slick('refresh');
        }
      };

      /**
       * Hide tabs when a script is fired.
       */
      $(tabContent).addClass(tabContentHiddenClass);

      /**
       * Open tab depending on location hash.
       * If it's empty or invalid, open the first tab.
       */
      if (locationHash && currentButton.length) {
        currentButton.addClass(navigationBtnActiveClass);
        $(tabBody).find(`.${locationHash.substring(1)}`).removeClass(tabContentHiddenClass);
        refreshElements();
      } else {
        const href = $(navigationBtn[0]).attr('href');

        $(`a[href="${href}"]`).addClass(navigationBtnActiveClass);
        $(tabContent[0]).removeClass(tabContentHiddenClass);
      }

      /**
       * Open tab on button click
       */
      $(navigationBtn).on('click', function () {
        const $thisButton = jQuery(this);
        const href = $thisButton.attr('href');
        if (!($thisButton.hasClass(navigationBtnActiveClass))) {
          $(navigationBtn).removeClass(navigationBtnActiveClass);
          $thisButton.addClass(navigationBtnActiveClass);
          $(tabContent).addClass(tabContentHiddenClass);
          $(tabBody).find(`.${href.substring(1)}`).removeClass(tabContentHiddenClass);
          window.location.hash = href;
        }

        refreshElements();

        return false;
      });
    }
  });
})(jQuery);
